
let prefix = '/api/units';

function getCatUnits(){
    return window.axios.get(prefix+'/index');
}

export default {
    getCatUnits,
}